/* PartnerAdRotator — cycles the Play Tsoro partner creatives inside the free
   play loop. Hidden entirely for paid subscribers. Impressions and clicks are
   tracked against the `free-loop-rotator` placement for admin analytics. */
import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';
import { isPaidSubscriber } from '@/lib/subscription';

const PARTNER_URL = 'https://www.playtsoro.com';
const ROTATE_MS = 12000;
const SLUG = 'free-loop-rotator';

const CREATIVES = [
    { key: 'plant-a-seed', img: '/brand/tsoro_portrait_plant_a_seed.png', alt: 'Play Tsoro — Plant a seed. Plan a move. A Zimbabwean strategy game.' },
    { key: 'teach-strategy', img: '/brand/tsoro_portrait_teach_strategy.png', alt: 'Play Tsoro — Teach strategy through play. Tutorial, AI levels and 2-player.' },
    { key: 'continent-of-cousins', img: '/brand/tsoro_portrait_continent_of_cousins.png', alt: 'Play Tsoro — One game, a continent of cousins. African mancala variants.' },
];

export default function PartnerAdRotator({ className = '' }) {
    const { user } = useAuth();
    const adFree = isPaidSubscriber(user);
    const [idx, setIdx] = useState(() => Math.floor(Date.now() / ROTATE_MS) % CREATIVES.length);

    useEffect(() => {
        if (adFree) return undefined;
        const t = setInterval(() => setIdx((i) => (i + 1) % CREATIVES.length), ROTATE_MS);
        return () => clearInterval(t);
    }, [adFree]);

    useEffect(() => {
        if (adFree) return;
        api.post(`/ads/placements/${SLUG}/impression`).catch(() => {});
    }, [idx, adFree]);

    if (adFree) return null;

    const creative = CREATIVES[idx];
    return (
        <div className={`mt-10 ${className}`} data-testid="partner-ad-rotator">
            <p className="text-[10px] uppercase tracking-wider text-lq-ink-500 mb-2">Sponsored · family-safe partner</p>
            <a
                href={PARTNER_URL}
                target="_blank"
                rel="noopener noreferrer sponsored"
                onClick={() => api.post(`/ads/placements/${SLUG}/click`).catch(() => {})}
                className="block rounded-2xl overflow-hidden border border-lq-ink-100 shadow-sm hover:shadow-md transition-shadow"
                style={{ background: '#f7f1e8' }}
                data-testid="partner-ad-link"
            >
                <img
                    key={creative.key}
                    src={creative.img}
                    alt={creative.alt}
                    className="w-full h-auto max-h-[440px] object-contain mx-auto block animate-in fade-in duration-700"
                    loading="lazy"
                    decoding="async"
                    data-testid={`partner-ad-creative-${creative.key}`}
                />
                <div className="px-4 py-1 text-[10px] uppercase tracking-wider text-right text-lq-ink-500 bg-black/5">Ad · playtsoro.com</div>
            </a>
        </div>
    );
}
